import { useState } from 'react';
import WalletInfoCard from '../common/walletInfoCard';
import AddCashModal from '../dialogs/add-cash-dialog';

const VoucherWalletInfo = () => {
  const [addCashModal, setAddCashModal] = useState(false);

  return (
    <>
      <AddCashModal
        open={addCashModal}
        onClose={() => setAddCashModal(false)}
      />
      <div className="mb-4">
        <WalletInfoCard
          amount=" 4,686"
          lastTransaction=" 1,050"
          lastTransactionText="Last Transaction"
          title="Wallet Balance"
          buttonText="Add Cash"
          onButtonClick={() => setAddCashModal(true)}
        />
      </div>
    </>
  );
};

export default VoucherWalletInfo;
